import { Box, Typography } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { renderToString } from 'react-dom/server'

const styles = {
    wrapper: {
        bgcolor: "#fff",
        borderRadius: "12px",
        px: 3,
        py: 3,
        "& h2": {
            color: "#1E1E1F",
            fontSize: 20,
            fontWeight: 600,
            mb: 2
        },
    },
};

const Series = [
    {
        color: "#FFDE59",
        width: "10px",
        data: [20, 8, 34, 15]
    }]

const options = {
    chart: {
        height: "auto ",
        // width: "100%",
        type: 'area',
        toolbar: { show: false },
        zoom: { enabled: false },
        sparkline: {
            enabled: true,
        }
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: 'smooth',
        width: 2
    },
    xaxis: {
        type: 'category',
        trim: true,
        labels: {
            offsetX: 5,
        },
        tooltip: {
            enabled: false
        },
        axisBorder: {
            show: false,
        }
    },
    yaxis: {
        show: false,
        forceNiceScale: true,
    },
    tooltip: {
        shared: false,
        intersect: false,
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            return renderToString(
                <div className="salesGraphContainer" >
                    <p className="salesMonth">Total Sales</p>
                    <h3 className="salesMonthValue">$6590</h3>
                </div>
            )
        },
    },
    legend: {
        show: false
    },
    fill: {
        opacity: 1,
        gradient: {
            type: 'vertical',
            shadeIntensity: 0,
            opacityFrom: 0.6,
            opacityTo: 0,
            stops: [0, 200]
        }
    },
    grid: {
        show: false,
    }
}

function SalesReport() {
    return (
        <>
            <Box sx={styles.wrapper}>
                <Typography component="h2">Sales Report</Typography>
                <ReactApexChart options={options} series={Series} type="area" height={120} />
            </Box>
        </>
    );
}

export default SalesReport;
